import useAiChatToolLabel from '../../hooks/useAiChatToolLabel';
import useAiChatToolStatus from '../../hooks/useAiChatToolStatus';
import AiChatToolCard from '../AiChatToolCard';

import type { ReactElement } from 'react';
import type { IAiChatToolCallOf } from '../../interfaces/IAiChatToolCall';

/**
 * The `writeDocument` tool call: a document stored under a title for a later turn or chat.
 *
 * Shows the title. The document itself (`part.input.data`) is not shown.
 */
function WriteDocumentToolCall({ part }: IAiChatToolCallOf<'writeDocument'>): ReactElement {
  const label = useAiChatToolLabel('writeDocument');
  const status = useAiChatToolStatus(part.state);

  return (
    <AiChatToolCard name={label} status={status} errorText={part.errorText}>
      {part.input?.title}
    </AiChatToolCard>
  );
}

export default WriteDocumentToolCall;
